<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
              <h1 class="page-title-accessibility" tabindex="-1" pplAutoFocusHeader>Consumer Referrals</h1>
            <div class="action">
                <ppl-button label="Create New Consumer Referral" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" [authorizeButton]="[pageId, 'newProviderReferral']"
                    (click)="onNewReferral()"></ppl-button>
            </div>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="table-style">
                    <ppl-list-table
                        rowDataAccessibilityKey="tracking_number"
                        [pageConfig]="programName"
                        [sharedDataKey]="sharedDataKey"
                        (rowDetailEvent)="rowClicked($event)"
                        [loadPage]="lazyLoad"
                        [columnsToBeHidden]="columnsToBeHidden"
                        [actionsToBeHidden]="actionsToBeHidden"
                        [showSelectAction]="showSelectAction"
                        [jsonList]="'list_referrals'"
                        [searchDropdownValues]="contactStsReasonLkpList"
                        [searchDropdownValuesByColumn]="{ application_status_lkp: applicationStatusSearchValues }">
                    </ppl-list-table>
                </div>
            </div>
        </div>
    </div>
    }

</ng-container>